import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  pageContainer: {
    '& .MuiDataGrid-columnHeaderTitleContainerContent': {
      width: '100%'
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiChip-root': {
      marginLeft: '10px'
    }
  },
  cellContent: {
    padding: '5px 10px'
  },
  cellDescriptionContent: {
    overflow: 'hidden',
    padding: '5px 10px',
    textOverflow: 'ellipsis'
  },
  rightAlign: {
    width: '100%',
    textAlign: 'right'
  }
}));
export default useStyles;